import React from 'react';
import Box from '-/style/base/Box';
import Subhead from '-/style/base/Subhead';
import SubSubHead from '-/style/base/SubSubHead';
import { GET_COMPANY_MONDAY_REPORT_NEW_THS_WEEK } from '-/gql/company';
import { graphql } from 'react-apollo';
import { get } from 'lodash';
import styled from 'styled-components';
import { defaultProps } from 'recompose';

import { groupByPrimaryThemePriority, sortBySeries } from './utils';
import StandardTable from './StandardTable';
import LoadingLogo from '-/components/LoadingLogo';
import { NewThisWeekRow } from './StandardRow';
import { NewThisWeekHeader } from './StandardHeader';
import { StyledEmptyRow } from '-/style/base/Table';
const EmptyRow = <StyledEmptyRow colSpan={8}>No companies.</StyledEmptyRow>;

const Section = styled.div`
    margin-bottom: 15px;
`;
const HorizScroller = styled.div`
    overflow-x: scroll;
`;
const FocusRow = defaultProps({
    priority: 'Focus'
})(NewThisWeekRow);
const NonFocusRow = defaultProps({
    priority: 'Non-Focus'
})(NewThisWeekRow);
const AvoidRow = defaultProps({
    priority: 'Avoid'
})(NewThisWeekRow);


const NewThisWeek = props => {
    const { data = {} } = props;
    const { loading } = data;
    const rawCompanies = get(data, 'CompanyMondayReport.newThisWeek', []);
    const rawCompaniesSorted = sortBySeries(rawCompanies);

    const { focus = [], nonFocus = [], avoid = [] } = groupByPrimaryThemePriority(rawCompaniesSorted);
    if (loading) {
        return <LoadingLogo />;
    }
    return (
        <Box>
            <Subhead>New This Week</Subhead>
            <Section>
                <SubSubHead>Focus</SubSubHead>
                <HorizScroller>
                    <StandardTable
                        minWidth={1300}
                        data={focus}
                        Row={FocusRow}
                        Header={NewThisWeekHeader}
                        EmptyRow={EmptyRow}
                    />
                </HorizScroller>
            </Section>
            <Section>
                <SubSubHead>Non-Focus</SubSubHead>
                <HorizScroller>
                    <StandardTable
                        minWidth={1300}
                        data={nonFocus}
                        Row={NonFocusRow}
                        Header={NewThisWeekHeader}
                        EmptyRow={EmptyRow}
                    />
                </HorizScroller>
            </Section>
            <Section>
                <SubSubHead>Avoid</SubSubHead>
                <HorizScroller>
                    <StandardTable
                        minWidth={1300}
                        data={avoid}
                        Row={AvoidRow}
                        Header={NewThisWeekHeader}
                        EmptyRow={EmptyRow}
                    />
                </HorizScroller>
            </Section>
        </Box>
    );
};

export default graphql(GET_COMPANY_MONDAY_REPORT_NEW_THS_WEEK)(
    NewThisWeek
);
